import DestinationCard from './DestinationCard';

export default DestinationCard;
